export const getImageUrl = (url, isWealth = false) => {
  if (!url) return '';
  
  // Replace windows backslashes with forward slashes
  let cleanUrl = url.replace(/\\/g, '/');

  if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://') || cleanUrl.startsWith('blob:')) {
    return cleanUrl;
  }

  // Ensure it starts with a slash
  if (!cleanUrl.startsWith('/')) {
    cleanUrl = `/${cleanUrl}`;
  }

  if (isWealth) {
    // Properly encode URL path components to handle spaces and '#' characters in Wealth API image names
    const encodePath = (path) => path.split('/').map(encodeURIComponent).join('/');
    return `https://api.wealthassociate.in${encodePath(cleanUrl)}`;
  }

  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5002';
  const cleanBase = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  return `${cleanBase}${cleanUrl}`;
};

export const getDefaultPropertyImage = (category = '', subCategory = '') => {
  const cat = category.toLowerCase();
  const sub = subCategory.toLowerCase();

  // Agricultural & Farm
  if (cat.includes('agricultur') || sub.includes('farm') || cat.includes('farm')) {
    return 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80&fm=webp'; // Farm/Field
  }
  
  // Commercial & Office
  if (cat.includes('commercial') || sub.includes('office') || sub.includes('shop')) {
    return 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80&fm=webp'; // Office building
  }

  // Industrial
  if (cat.includes('industrial') || sub.includes('warehouse')) {
    return 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800&q=80&fm=webp'; // Warehouse
  }

  // Plot / Land (Residential or Open)
  if (cat.includes('plot') || cat.includes('land') || sub.includes('plot')) {
    return 'https://images.unsplash.com/photo-1629016943072-0bf0ee4e2c65?w=800&q=80&fm=webp'; // Open grassy land
  }

  // Villa / Independent House
  if (sub.includes('villa') || sub.includes('independent') || cat.includes('independent')) {
    return 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80&fm=webp'; // Villa exterior
  }

  // Projects (Builders)
  if (cat.includes('project')) {
    return 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80&fm=webp'; // Modern apartment building
  }

  // Default Residential / Apartment / Flat
  return 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80&fm=webp'; // Interior living room
};
